import { Table } from '@mantine/core';
import classes from './TouringCardTable.module.css';

export const TouringCardTable: React.FC<React.PropsWithChildren> = ({
  children,
}) => <Table className={classes.table}>{children}</Table>;
